import React, { Component } from 'react';
import './CreatorUploadMonetizationForm.css';

class CreatorMonetizationMintPriceForm extends Component {
  constructor(props) {
    super(props);
    this.state = {value: (props.params && props.params.mintPrice ? props.params.mintPrice : "")};

    this.handleChange = this.handleChange.bind(this);

  }

  async handleChange(event) {
    if(this.props.checkString(event.target.value) || event.target.value === ""){
      this.setState({value: event.target.value});
      await this.props.setMintPrice(event.target.value);
    }
  }

  render() {
    return (
      <div>
        <label className="text-black">
          <input placeholder="Mint price" className = "placeholder-gray-500 font-medium w-full p-4 mt-8 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-900" type="text" value={this.state.value} onChange={this.handleChange} />
        </label>
        {
          this.state.value !== "" && !isNaN(this.props.usdPrice)
            ?
          "$ " + (this.state.value * this.props.usdPrice).toFixed(2)
            :
          null
        }
        {
          this.state.value !== "" && !isNaN(this.props.usdPrice)
            ?
          <br />
            :
          null
        }
        Price in ETH to mint at.
      </div>


    );
  }
}

export default CreatorMonetizationMintPriceForm;
